var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8071_22696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24994 9.99979C7.04487 9.99979 8.49994 8.54471 8.49994 6.74979C8.49994 4.95486 7.04487 3.49979 5.24994 3.49979C3.45501 3.49979 1.99994 4.95486 1.99994 6.74979C1.99994 8.54471 3.45501 9.99979 5.24994 9.99979Z",
    stroke: "#8B8C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.639282 12.4997C1.13871 11.7318 1.82203 11.1008 2.6272 10.664C3.43237 10.2272 4.33388 9.99841 5.24991 9.99841C6.16593 9.99841 7.06745 10.2272 7.87262 10.664C8.67778 11.1008 9.3611 11.7318 9.86053 12.4997",
    stroke: "#8B8C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 9.99976C11.6659 9.99922 12.5675 10.2276 13.3727 10.6643C14.178 11.1009 14.8613 11.7318 15.3606 12.4998",
    stroke: "#8B8C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54303 3.73104C9.9876 3.55372 10.4659 3.47679 10.9436 3.50574C11.4214 3.53468 11.8868 3.6688 12.3067 3.89849C12.7266 4.12819 13.0906 4.4478 13.3727 4.83448C13.6548 5.22116 13.8479 5.66537 13.9384 6.13537C14.0289 6.60537 14.0145 7.08955 13.8961 7.55332C13.7778 8.01709 13.5585 8.449 13.2539 8.81818C12.9493 9.18736 12.5669 9.48471 12.134 9.68897C11.7012 9.89323 11.2285 9.99936 10.7499 9.99979",
    stroke: "#8B8C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8071_22696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9a6f06087310658ae0796419c4319a43.svg";
export { ForwardRef as ReactComponent };